import Loading from '@/shared/components/Carregando';
import MyContext from '@/shared/contexts/AppContext';
import { AttendanceSheetsTable } from '../perMonth/PerMonthTable';
import { AttendanceSheetsModals } from '../perMonth/PerMonthModals';
import { PendenciasFilters } from './PendenciasFilters';
import { useAttendanceSheetsPendencias } from '@/modules/business/attendance-sheet/presentation/pages/pendencias/usePendencias';
import { AttendanceSheetsPerMonthPdf } from '../../components/AttendanceSheetsPerMonthPDF';
import { exportFromJsxToPdf } from '@/shared/utils/pdf';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useContext, useEffect, useState } from 'react';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';

export function AttendanceSheetsPendenciasPage() {
  const context = useContext(MyContext);
  if (!context)
    throw new Error('Contexto deve ser usado dentro de um Provedor.');

  const { setActions } = useBreadcrumbActions();
  const [visibleColumnKeys, setVisibleColumnKeys] = useState<string[] | null>(null);
  const tableState = useDataTableState('estagiario.nome');

  const {
    statusBusca,
    setStatusBusca,
    filtroResponsavel,
    setFiltroResponsavel,
    filtroEstagiario,
    setFiltroEstagiario,
    filtrosStatus,
    registros,
    handleBuscar,
    responsaveis,
    estagiarios,
    exibirFiltroResponsavel,
    permissaoExcluirFolhas,
    selectedItem,
    setSelectedItem,
    folhaSelecionada,
    setFolhaSelecionada,
    showModalCriarFolha,
    setShowModalCriarFolha,
    showModalCriarFolhas,
    setShowModalCriarFolhas,
    showModalNotificacaoIndividual,
    setShowModalNotificacaoIndividual,
    showModalNotificacoes,
    setShowModalNotificacoes,
    showModalResponsavel,
    setShowModalResponsavel,
    showModalAssinaturas,
    setShowModalAssinaturas,
    folhaParaAssinaturas,
    setFolhaParaAssinaturas,
    loaded,
  } = useAttendanceSheetsPendencias(tableState);

  useEffect(() => {
    if (!loaded) return;

    setActions({
      print: {
        label: 'Imprimir',
        onClick: () => {
          if (!registros) return;
          exportFromJsxToPdf(
            <AttendanceSheetsPerMonthPdf
              subtitulo="PENDÊNCIAS"
              referenciaPorLinha
              registrosVisiveis={registros[0] ?? []}
              totalRegistros={registros[1] ?? 0}
              visibleColumnKeys={visibleColumnKeys}
            />,
          );
        },
      },
    });

    return () => setActions({});
  }, [loaded, registros, setActions, visibleColumnKeys]);

  if (!loaded) return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h3>Folhas de Frequências</h3>
          <span className="blockquote-footer pb-4 text-end">
            Todas as folhas não concluídas.
          </span>
        </div>

        <div className="col-md-4">
          <br />
        </div>
      </div>
      <hr />

      <PendenciasFilters
        filtrosStatus={filtrosStatus}
        statusBusca={statusBusca}
        setStatusBusca={setStatusBusca}
        filtroResponsavel={filtroResponsavel}
        setFiltroResponsavel={setFiltroResponsavel}
        filtroEstagiario={filtroEstagiario}
        setFiltroEstagiario={setFiltroEstagiario}
        responsaveis={responsaveis}
        estagiarios={estagiarios}
        tableState={tableState}
        exibirFiltroResponsavel={exibirFiltroResponsavel}
      />

      {registros && (
        <AttendanceSheetsTable
          registros={registros}
          tableState={tableState}
          handleBuscar={handleBuscar}
          setSelectedItem={setSelectedItem}
          setShowModalCriarFolha={setShowModalCriarFolha}
          setFolhaSelecionada={setFolhaSelecionada}
          setShowModalResponsavel={setShowModalResponsavel}
          setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
          setFolhaParaAssinaturas={setFolhaParaAssinaturas}
          setShowModalAssinaturas={setShowModalAssinaturas}
          permissaoExcluirFolhas={permissaoExcluirFolhas}
          showReferenciaColumn
          onVisibleColumnsChange={(keys) => setVisibleColumnKeys(keys)}
        />
      )}

      <AttendanceSheetsModals
        folhaSelecionada={folhaSelecionada}
        selectedItem={selectedItem}
        showModalResponsavel={showModalResponsavel}
        setShowModalResponsavel={setShowModalResponsavel}
        showModalNotificacaoIndividual={showModalNotificacaoIndividual}
        setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
        showModalCriarFolha={showModalCriarFolha}
        setShowModalCriarFolha={setShowModalCriarFolha}
        showModalCriarFolhas={showModalCriarFolhas}
        setShowModalCriarFolhas={setShowModalCriarFolhas}
        showModalNotificacoes={showModalNotificacoes}
        setShowModalNotificacoes={setShowModalNotificacoes}
        isExecuting={false}
        handleCriarFolha={() => setShowModalCriarFolha(false)}
        handleGenerateAttendanceSheetsForMonth={async () => setShowModalCriarFolhas(false)}
        registros={registros}
        mesBusca={new Date()}
        showModalAssinaturas={showModalAssinaturas}
        setShowModalAssinaturas={setShowModalAssinaturas}
        folhaParaAssinaturas={folhaParaAssinaturas}
      />
    </>
  );
}
